module.exports = __webpack_public_path__ + "0099351c4f0001a23ed90378e319771c.png";